angular
  .module('app')
  .controller('IndexController', IndexController);

IndexController.$inject = ['AuthService', 'Session', 'AUTH_EVENTS', '$rootScope'];

function IndexController(AuthService, Session, AUTH_EVENTS, $rootScope) {
  var vm = this;
  vm.error = false;

  vm.key = function () {
    vm.error = false;
    vm.passworderror = false;
  };

  vm.login = function () {
    $rootScope.loading = true;
    AuthService.login(vm.credentials).then(function () {
      $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
      $rootScope.loading = false;
      Session.go('dashboard.main');
    })
    .catch(function () {
      vm.error = true;
      $rootScope.loading = false;
      $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
    });
  };

  vm.register = function () {
    $rootScope.loading = true;
    if (vm.user.password === vm.user.confirmpassword) {
      AuthService.register(vm.user).then(function () {
        $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
        $rootScope.loading = false;
        Session.go('dashboard.main');
      })
      .catch(function () {
        vm.passworderror = true;
        $rootScope.loading = false;
        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
      });
    } else {
      vm.passworderror = true;
      $rootScope.loading = false;
    }
  };
}
